
import {
  defineComponent, reactive, computed, watch,
} from 'vue';
import { useAppBase } from '@/core/composables/AppBase';
import { ICadastro } from '@/models/Entidades/ICadastro';
import ComunicacaoApi from '@/core/components/UI/ComunicacaoApi.vue';
import ServicoCadastro from '@/servicos/ServicoCadastro';
import { EStatusResposta, IResposta } from '@/core/models/IResposta';
import CampoCpf from '@/core/components/UI/CampoCpf.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import SelecionarSimNao from '@/core/components/UI/SelecionarSimNao.vue';
import storeApp from '@/store/storeApp';
import { ETipoRelacaoCadastro } from '@/models/Enumeradores/ETipoRelacaoCadastro';
import CampoTelefone from '@/core/components/UI/CampoTelefone.vue';
import CampoEmail from '@/core/components/UI/CampoEmail.vue';
import { ETipoDocumento } from '@/models/Enumeradores/ETipoDocumento';
import ComboTipoDocumento from '@/components/ComboTipoDocumento.vue';
import CampoCnpj from '@/core/components/UI/CampoCnpj.vue';

export default defineComponent({
  name: 'CadastroPessoaModal',
  props: {
    visivel: {
      type: Boolean,
    },
    codigoCadastro: {
      type: Number,
      default: 0,
    },
  },
  components: {
    ComunicacaoApi,
    ComboTipoDocumento,
    CampoCnpj,
    CampoCpf,
    CampoTelefone,
    CampoEmail,
    SelecionarSimNao,
  },
  emits: ['operacaoConcluida', 'update:visivel'],
  setup(props, { emit }) {
    const {
      appBase, apresentarComunicacaoApi, ocultarComunicacaoApi, apresentarResposta,
    } = useAppBase();
    const servicoCadastro = new ServicoCadastro();
    const state = reactive({
      pessoa: {} as ICadastro,
      cpfCnpj: '',
      computedVisivel: computed({
        get: () => props.visivel,
        set: (val: boolean) => {
          emit('update:visivel', val);
        },
      }),
    });

    function limparDados() {
      state.pessoa = {} as ICadastro;
      state.pessoa.codigo = 0;
      state.pessoa.tipo = ETipoRelacaoCadastro.Pessoa;
      state.pessoa.tipoDocumento = ETipoDocumento.CPF;
      state.pessoa.status = true;
      state.cpfCnpj = '';
    }

    async function obterCadastro(codigo:number) {
      appBase.carregando = true;
      state.pessoa = await servicoCadastro.obter(codigo);
      state.cpfCnpj = state.pessoa.numeroDocumento;

      appBase.carregando = false;
    }

    watch(async () => state.computedVisivel, async () => {
      appBase.carregando = true;
      limparDados();
      if (state.computedVisivel) {
        if (props.codigoCadastro > 0) {
          await obterCadastro(props.codigoCadastro);
        }
      }
      appBase.carregando = false;
    });

    async function salvar() {
      appBase.resposta = {} as IResposta;

      apresentarComunicacaoApi('Aguarde por favor... Estamos salvando as informações da pessoa.');
      if (state.pessoa.codigo === 0) {
        appBase.resposta = await servicoCadastro.incluir(state.pessoa);
      } else {
        appBase.resposta = await servicoCadastro.atualizar(state.pessoa);
      }
      if (appBase.resposta.status === EStatusResposta.Sucesso) {
        emit('operacaoConcluida', appBase.resposta.codigo);
        ocultarComunicacaoApi();
        state.computedVisivel = false;
      } else {
        apresentarResposta();
      }
    }

    return {
      appBase,
      storeApp,
      state,
      salvar,
      UtilitarioGeral,
      ETipoDocumento,
    };
  },
});
